const summaryTheme = {
  "colors": ["#d35400", "#2980b9", "#2ecc71", "#f1c40f", "#2c3e50", "#7f8c8d"],

};

export default summaryTheme;



// WEBPACK FOOTER //
// ./src/components/charts/highcharts-themes/summary.js